module.exports = __webpack_public_path__ + "img/bg2.aff92e93.png";